import React from 'react'
import {motion} from 'framer-motion'

import { transitionPages } from "./animations"

function ComponentContainer({children}) {
    return (
        <motion.div 
            initial={transitionPages.initial}
            exit={transitionPages.exit}
            animate={transitionPages.animate}
            transition={transitionPages.transition}
            className="component">
            <div className="component__container">
                {children}
            </div>
        </motion.div>
    )
}

export default ComponentContainer
